import type { Middleware } from '@nuxt/types';

/**
 * Middleware to set the AB test branch from query parameters
 */
const abTestSetFromQueryMiddleware: Middleware = ({ route, $ab }) => {
  const abTests = Object.entries(route.query).filter(([key]) => {
    return key.startsWith('ab-test-');
  });
  if (!abTests.length) return;

  abTests.forEach(([key, value]) => {
    const testName = key.replace('ab-test-', '');
    const ONE_DAY = 1;
    $ab.init(testName, ONE_DAY, value as 'a' | 'b');
  });
};

export default abTestSetFromQueryMiddleware;
